import React, {Component} from "react"
import PropTypes from 'prop-types';
import RichText from "../../Util/RichText"
import AttributesTable from "./AttributesTable"
import {FormattedMessage} from 'react-intl';

const AttributesTableContainer = ({attributes, copyTable}) => (
    <div>
        <AttributesTable attributes={attributes}/>
        <div className="attributes-button-section">
            <button onClick={copyTable} className="btn btn-sm btn-primary">
                <span className="fas fa-list-alt"/> <FormattedMessage id="attributes_table.copy"/>
            </button>
        </div>
        <div className="attribute-table-print">
            <AttributesTable attributes={attributes} print={true}/>
        </div>
    </div>
);

class Attributes extends Component {
    constructor() {
        super();

        this.copyTable = this.copyTable.bind(this);
    }

    render() {
        const {event, attributes} = this.props;

        return (
            <div className='media-body'>
                {event.threadTypeHeader
                    ? <RichText content={event.threadTypeHeader}/>
                    : null
                }
                {AttributesTable.filterAttributes(attributes).length
                    ? <AttributesTableContainer attributes={attributes} copyTable={this.copyTable}/>
                    : null
                }
                {event.threadTypeFooter
                    ? <RichText content={event.threadTypeFooter}/>
                    : null
                }
            </div>
        )
    }

    copyTable() {
        selectElementContents(document.getElementById('attribute-table-print'));
        document.execCommand('copy');
    }
}

Attributes.propTypes = {
    event: PropTypes.any.isRequired,
    attributes: PropTypes.any.isRequired
};

const selectElementContents = (el) => {
    let body = document.body,
        range,
        sel;

    if (document.createRange && window.getSelection) {
        range = document.createRange();
        sel = window.getSelection();
        sel.removeAllRanges();

        try {
            range.selectNodeContents(el);
            sel.addRange(range);
        } catch (e) {
            range.selectNode(el);
            sel.addRange(range);
        }
    } else if (body.createTextRange) {
        range = body.createTextRange();
        range.moveToElementText(el);
        range.select();
    }
};

export default Attributes;
